import Button from '@material-ui/core/Button';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  padding: 12px 0;

  .progress-area {
    padding: 0 45px;
    .progress-head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      h4 {
        font-family: Roboto;
        font-style: italic;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        color: #5e5e5e;
      }
    }

    .MuiLinearProgress-root {
      height: 13.62px;
      border: 1px solid #c4c4c4;
      background: #fff;
      .MuiLinearProgress-bar {
        background: #3c71dd;
      }
    }
  }

  .gba-data {
    margin-top: 60px;
    width: 100%;
    height: 264px;
    padding: 20px 64px;
    background: #f0f0f0;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .layer {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 16px;
      .title {
        display: flex;
        width: 80%;
        p,
        span {
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 10px;
          line-height: 16px;
          color: #5e5e5e;
        }
        p {
          margin: 0;
          max-width: 50%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          font-style: italic;
        }
      }
      .stat-icon {
        color: #3c71dd;
        &.error {
          color: #c24938;
        }
      }
      .fake-progress {
        margin-top: 2px;
        height: 3px;
        width: 100%;
        background: #3c71dd;
        &.error {
          background: #c24938;
        }
      }
      .remove-button {
        position: absolute;
        right: -20px;
        top: 2;
        border: none;
        padding: 0;
        background: transparent;
        color: #aeaeae;
      }
    }
  }

  .animated-svg {
    display: none;
    margin-top: 20px;
    height: 75%;
    justify-content: center;
    align-items: center;
    iframe {
      flex: 1;
    }
    &.show-animation {
      display: flex;
    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    .button-area {
      width: 200px;
      padding: 10px;
      margin: 0 auto 20px;
    }
  }
`;

/**
 * Estilização do componente StyledButton
 */
export const StyledButton = styled(Button)`
  width: 100%;

  &.MuiButton-root {
    text-transform: none;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 16px;
  }

  &.MuiButton-contained {
    color: #fff;
    background: #3c71dd;

    &:hover {
      background: #3463c1;
    }
  }

  &:disabled {
    background: #aeaeae;
  }
`;
